import React from "react";
import { GlobalProps } from "../../App";
import { inject, observer } from "mobx-react";
import { useHistory } from "react-router";
import { authService } from "../../services/AuthService";
import useSnackBar from "../../hooks/useSnackBar";
import LoginPage from "../components/LoginPage/LoginPage";
import { firebaseService } from "../../services/FirebaseService";
import { EMAIL_FOR_SIGN_IN, REDIRECT_URL } from "../../utils/ConstantUtils";

const LoginView: React.FC<GlobalProps> = (props: GlobalProps) => {
  const history = useHistory();
  const notify = useSnackBar();
  const store = props.store;

  const signInWithGoogle = async () => {
    try {
      await authService.signInWithGoogle();
      history.push(`${props.store?.redirectUrl}`);
    } catch (error) {
      notify("error", "There was a problem signing in with Google.");
    }
  };

  const signInWithApple = async () => {
    try {
      await authService.signInWithApple();
      history.push(`${props.store?.redirectUrl}`);
    } catch (error) {
      notify("error", "There was a problem signing in with Apple.");
    }
  };

  const signInWithEmailAndPassword = async (
    email: string,
    password: string
  ) => {
    try {
      await authService.signInWithEmailAndPassword(email, password);
      history.push(`${props.store?.redirectUrl}`);
    } catch (error) {
      notify("error", "There was a problem signing in.");
    }
  };

  const sendMagicLink = async (email: string) => {
    try {
      await firebaseService.sendMagicLink(email, "login");
      localStorage.setItem(EMAIL_FOR_SIGN_IN, email);
      localStorage.setItem(REDIRECT_URL, store?.redirectUrl!);
    } catch (error) {
      notify("error", "There was a problem sending the magic link.");
    }
  };

  return (
    <>
      <LoginPage
        sendMagicLink={sendMagicLink}
        signInWithApple={signInWithApple}
        signInWithGoogle={signInWithGoogle}
        signInWithEmailAndPassword={signInWithEmailAndPassword}
      />
    </>
  );
};

export default inject("store")(observer(LoginView));
